'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$GroupId$() {
  this.c7O = null;
  this.c7P = false;
  this.c7M = null;
  this.c7N = false;
}
export { $c_Lpresto_types$GroupId$ as $c_Lpresto_types$GroupId$ };
$p = $c_Lpresto_types$GroupId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$GroupId$;
/** @constructor */
function $h_Lpresto_types$GroupId$() {
}
export { $h_Lpresto_types$GroupId$ as $h_Lpresto_types$GroupId$ };
$h_Lpresto_types$GroupId$.prototype = $p;
$p.cJ7 = (function() {
  if ((!this.c7P)) {
    this.c7O = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j9;
    this.c7P = true;
  }
  return this.c7O;
});
$p.pb = (function() {
  if ((!this.c7N)) {
    this.c7M = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().e1;
    this.c7N = true;
  }
  return this.c7M;
});
var $d_Lpresto_types$GroupId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$GroupId$, "presto.types$GroupId$", ({
  a0i: 1,
  D: 1
}));
export { $d_Lpresto_types$GroupId$ as $d_Lpresto_types$GroupId$ };
var $n_Lpresto_types$GroupId$;
function $m_Lpresto_types$GroupId$() {
  if ((!$n_Lpresto_types$GroupId$)) {
    $n_Lpresto_types$GroupId$ = new $c_Lpresto_types$GroupId$();
  }
  return $n_Lpresto_types$GroupId$;
}
export { $m_Lpresto_types$GroupId$ as $m_Lpresto_types$GroupId$ };
//# sourceMappingURL=presto.types$-Group-Id$.js.map
